import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LangProvider } from "./lib/i18n";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Declare from "./pages/Declare";
import Prestations from "./pages/Prestations";
import ProFormas from "./pages/ProFormas";
import Controls from "./pages/Controls";
import Returns from "./pages/Returns";
import Settings from "./pages/Settings";
import MyTariffs from "./pages/MyTariffs";
import MyDrivers from "./pages/MyDrivers";
import Dashboard from "./pages/Dashboard";
import ResetPassword from "./pages/ResetPassword";
import Signup from "./pages/Signup";
import VerifyEmail from "./pages/VerifyEmail";
import Simulation from "./pages/Simulation";
import PmReports from "./pages/PmReports";
import { GoogleCallback } from "./components/GoogleAuth";
import { useLocation } from "react-router-dom";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleCallback hash={location.hash} />;
  return (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reinitialiser" element={<ResetPassword />} />
          <Route path="/inscription" element={<Signup />} />
          <Route path="/inscription/verifier" element={<VerifyEmail />} />
          <Route path="/" element={<Home />} />
          <Route path="/declarer" element={<Guard roles={["soustraitant", "chauffeur"]}><Declare /></Guard>} />
          <Route path="/prestations" element={<Guard roles={["admin", "gestionnaire", "soustraitant"]}><Prestations /></Guard>} />
          <Route path="/proformas" element={<Guard roles={["admin", "gestionnaire", "soustraitant"]}><ProFormas /></Guard>} />
          <Route path="/controles" element={<Guard roles={["admin", "gestionnaire"]}><Controls /></Guard>} />
          <Route path="/pm-reports" element={<Guard roles={["admin", "gestionnaire"]}><PmReports /></Guard>} />
          <Route path="/retours" element={<Guard roles={["admin", "gestionnaire", "soustraitant"]}><Returns /></Guard>} />
          <Route path="/tarifs" element={<Guard roles={["soustraitant"]}><MyTariffs /></Guard>} />
          <Route path="/simulation" element={<Guard roles={["admin", "gestionnaire", "soustraitant"]}><Simulation /></Guard>} />
          <Route path="/chauffeurs" element={<Guard roles={["soustraitant"]}><MyDrivers /></Guard>} />
          <Route path="/tableau-de-bord" element={<Guard roles={["admin", "gestionnaire"]}><Dashboard /></Guard>} />
          <Route path="/parametres" element={<Guard roles={["admin", "gestionnaire"]}><Settings /></Guard>} />
          <Route path="*" element={<Home />} />
        </Routes>
  );
}

const HOME = { admin: "/controles", gestionnaire: "/controles", soustraitant: "/declarer", chauffeur: "/declarer" };

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="tl-loading" data-testid="auth-loading">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={HOME[user.role]} replace />;
  return <Layout>{children}</Layout>;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user ? HOME[user.role] : "/login"} replace />;
}

export default function App() {
  return (
    <LangProvider>
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
    </LangProvider>
  );
}
